import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
const rows = [{
  without: 'Sin diagnóstico',
  loss: 'Errores que corregís gratis'
}, {
  without: 'Sin corrección',
  loss: 'Clientes que no vuelven'
}, {
  without: 'Sin presentación',
  loss: 'Precio que siempre negocian'
}, {
  without: 'Sin método de cobro',
  loss: 'Siempre compitiendo por precio'
}, {
  without: 'Sin sistema',
  loss: 'El mismo ciclo, para siempre'
}];
export function CostOfInaction() {
  return <section aria-label="El costo de no tenerlo" className="border-b border-ink-700 bg-ink-900 py-16 sm:py-20" data-id="element-32" data-mp="38wk02rgu5sbd">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-33" data-mp="3dp3nsh98m3tw">
        <SectionHeading label="El costo de no tenerlo" title="⚖️ Lo que te cuesta seguir igual" data-id="element-34" data-mp="3inogzwq2nn8u" />

        <ul className="mt-10 grid gap-px bg-ink-700 sm:grid-cols-2 lg:grid-cols-1" data-id="element-35" data-mp="3nnau865wh3hn">
          {rows.map((row, i) => <motion.li key={row.without} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex flex-col gap-2 bg-ink-950 p-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8" data-id="element-36" data-mp="3sm465u5jgmfp" data-mpi={i}>
              <span className="display text-base text-ash sm:text-lg" data-id="element-37" data-mp="30i9jndcx0v4g">{row.without}</span>
              <span className="text-sm font-semibold text-bone sm:text-base lg:text-right" data-id="element-38" data-mp="108l6afox5eh">
                {row.loss}
              </span>
            </motion.li>)}
        </ul>

        <p className="display mt-10 text-center text-2xl text-bone sm:text-3xl" data-id="element-39" data-mp="3ng3263mdjmah">
          “El próximo trabajo puede ser diferente.” ✂
        </p>
      </div>
    </section>;
}